/**
 * Makes listed properties optional, if they exist.
 */
export type OptionalKeysNonStrict<Object, OptionalKeys extends PropertyKey> = Omit<Object, OptionalKeys> & {
    [K in OptionalKeys as Object extends { [key in K]?: unknown } ? K : never]?: Object extends { [key in K]?: unknown }
        ? Object[K]
        : never;
};
